import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {Title} from "@angular/platform-browser";


@Component({
  selector: 'app-applied-error',
  templateUrl: './applied-error.component.html',
  styleUrls: ['./applied-error.component.scss'],
})
export class AppliedErrComponent implements OnInit, OnDestroy {
  public changePasswordForm: FormGroup;
  public error_code;
  constructor(
    private renderer: Renderer2,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService:Title,
  ) {
    this.titleService.setTitle("JOYFIT 法人契約申込み・再審査フォーム");
  }
  public logoUrl;
  ngOnInit() {
    this.logoUrl = environment.production ? 'assets/img/fit365_logo.svg' : 'assets/img/fit365_logo_test_mode.svg';
    this.renderer.addClass(document.querySelector('app-root'), 'company-page');
    this.error_code = this.route.snapshot.paramMap.get('code');
    if(!this.error_code){
      document.getElementById('err_title1').style.display = 'block';
    } else {
      this.translate.get('ETITLE.' + this.error_code).subscribe(
        (res) => {
          document.getElementById('err_title2').innerHTML = res
        }
      );
      document.getElementById('err_title1').style.display = 'none';
      document.getElementById('err_title2').style.display = 'block';
      this.translate.get('ERROR.' + this.error_code).subscribe(
        (res) => {
          document.getElementById('err_text2').innerHTML = res + '<br>' + '('+this.error_code+')'
          }
        );
      document.getElementById('err_text2').style.display = 'block';
      document.getElementById('err_text1').style.display = 'none';
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'company-page'
    );
  }
}
